import type { SocialNetwork } from "@loot-os/api-contract";

/**
 * The glyph for each network, ported verbatim from boxed-frontend's `components/icons/*Icon.tsx`
 * (one 40×40 path each), so the storefront footer and the dashboard's field labels draw the
 * same icons boxed.gg does. `fill="currentColor"`, so a caller colors it with `text-*`.
 */
const PATHS: Record<SocialNetwork, string> = {
  facebook:
    "M19.443 3.342c-8.41.275-15.486 7.076-16.068 15.471C2.76 27.695 9.112 35.2 17.51 36.462V24.417h-2.69a2.19 2.19 0 1 1 0-4.38h2.688v-2.915c0-4.827 2.352-6.945 6.364-6.945.595 0 1.103.013 1.535.035a1.99 1.99 0 0 1 1.881 1.996 2 2 0 0 1-2 2h-.736c-1.704 0-2.299 1.615-2.299 3.435v2.395h3.117c.985 0 1.738.879 1.588 1.852l-.18 1.168a1.61 1.61 0 0 1-1.588 1.362h-2.937v12.078C30.392 35.393 36.667 28.437 36.667 20c0-9.39-7.765-16.965-17.224-16.658",
  x: "m3.945 5 11.827 16.901L4.567 35h4.401l8.773-10.283L24.935 35h11.517l-12.37-17.708L34.567 5h-4.333l-8.115 9.48L15.498 5zm6.4 3.333h3.415l16.295 23.334H26.67z",
  discord:
    "M33.838 9.32a4.77 4.77 0 0 0-2.214-1.805c-1.971-.79-3.666-1.318-5.183-1.616-1.064-.208-2.118.315-2.624 1.301l-.127.246c-1.123-.124-2.316-.165-3.674-.13-1.393-.034-2.59.006-3.714.13l-.126-.246c-.506-.986-1.562-1.508-2.623-1.3-1.517.297-3.213.825-5.183 1.616a4.77 4.77 0 0 0-2.215 1.805C2.378 15.026.898 21.179 1.631 28.134a.8.8 0 0 0 .369.593c2.906 1.832 5.42 3.087 7.913 3.949 1.042.364 2.198-.043 2.813-.983l1.097-1.681c-.873-.33-1.726-.72-2.544-1.186a.8.8 0 0 1 .793-1.39 16.1 16.1 0 0 0 7.954 2.122c2.77 0 5.52-.734 7.953-2.121a.8.8 0 0 1 .793 1.389c-.845.482-1.728.884-2.633 1.219l1.129 1.681a2.44 2.44 0 0 0 2.022 1.086c.258 0 .518-.042.77-.129 2.5-.863 5.02-2.119 7.932-3.955a.8.8 0 0 0 .369-.593c.734-6.956-.746-13.11-4.523-18.815M14.886 23.186c-1.54 0-2.808-1.623-2.808-3.596 0-1.972 1.268-3.596 2.808-3.596 1.541 0 2.81 1.624 2.81 3.596 0 1.973-1.269 3.596-2.81 3.596m10.395-.02c-1.527 0-2.783-1.633-2.783-3.618s1.256-3.618 2.783-3.618 2.782 1.633 2.782 3.618-1.256 3.618-2.782 3.618",
  instagram:
    "M12.8 2.4C7.064 2.4 2.4 7.064 2.4 12.8v14.4c0 5.736 4.664 10.4 10.4 10.4h14.4c5.736 0 10.4-4.664 10.4-10.4V12.8c0-5.736-4.664-10.4-10.4-10.4zm16.8 6.4c.88 0 1.6.72 1.6 1.6s-.72 1.6-1.6 1.6-1.6-.72-1.6-1.6.72-1.6 1.6-1.6M20 11.2c4.856 0 8.8 3.944 8.8 8.8s-3.944 8.8-8.8 8.8-8.8-3.944-8.8-8.8 3.944-8.8 8.8-8.8m0 1.6c-3.968 0-7.2 3.232-7.2 7.2s3.232 7.2 7.2 7.2 7.2-3.232 7.2-7.2-3.232-7.2-7.2-7.2",
  youtube:
    "M35.919 11.6c-.319-1.76-1.838-3.04-3.6-3.44-2.638-.56-7.519-.96-12.8-.96-5.278 0-10.238.4-12.878.96-1.76.4-3.282 1.6-3.6 3.44-.322 2-.641 4.8-.641 8.4s.319 6.4.719 8.4c.322 1.76 1.84 3.04 3.6 3.44 2.8.56 7.6.96 12.881.96s10.081-.4 12.881-.96c1.76-.4 3.278-1.6 3.6-3.44.319-2 .719-4.881.8-8.4-.162-3.6-.562-6.4-.962-8.4M15.2 25.6V14.4l9.76 5.6z",
  tiktok:
    "M32.8 3.2H7.2c-2.206 0-4 1.794-4 4v25.6c0 2.206 1.794 4 4 4h25.6c2.206 0 4-1.794 4-4V7.2c0-2.206-1.794-4-4-4m-3.195 14.658a5.993 5.993 0 0 1-5.567-2.682v9.23a6.822 6.822 0 1 1-6.822-6.822c.142 0 .282.013.422.022v3.361c-.14-.017-.278-.042-.422-.042a3.481 3.481 0 1 0 0 6.963c1.923 0 3.622-1.515 3.622-3.438l.033-15.676h3.213a5.99 5.99 0 0 0 5.52 5.348z",
};

/**
 * One social network's icon, decorative: the link or label around it carries the name. Sized
 * by `className` (`size-4` by default), colored by the surrounding text color.
 */
export function SocialIcon({
  network,
  className = "size-4",
}: {
  network: SocialNetwork;
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path d={PATHS[network]} />
    </svg>
  );
}
